/* eslint-disable */
export default {
  flipHeader: 'Oproep omkeren naar...',
  flip: 'Omkeren',
  complete: 'Omkeren voltooien',
} as const;

// @key: @#@"flipHeader"@#@ @source: @#@"Flip Call to..."@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"complete"@#@ @source: @#@"Complete Flip"@#@
